import PropTypes from 'prop-types';
import React     from 'react';

import * as S                from './info-bundle.module.scss';
import { SubActionRow }      from '../sub-action-row';
import { InfoBm }            from '../info-bm/info-bm';
// import { CancelledBox }      from '../../../common/product/cancelled-box';
import { Expiry }            from '../../../common/product/expiry';
import { Price }             from '../../../common/product/price';
import { ProductName }       from '../../../common/product/prod-name';
// import { RemainingTime }     from '../../../common/product/remaining-time';
import { TagLine }           from '../../../common/product/tag-line';
// import HAPPY_STAR            from '../../../../assets/imgs/art/happy-star.svg';
// import MEH_STAR              from '../../../../assets/imgs/art/meh-star.svg';
import { useGlobalCtx }      from '../../../../context/ctx-hook';
// import * as ProductSelectors from '../../../../context/selectors/product-selectors';
// import * as UserSelectors    from '../../../../context/selectors/user-selectors';
// import { isInBetween }       from '../../../../helpers/time-helpers';
// import { getSimpPriceWarning }   from '../../../../helpers/skunotices-helpers';
import { getProductLogo } from '../../../../context/selectors/product-selectors';
import * as BillSelector from  '../../../../context/selectors/bill-selectors';



const InfoBundle = ({product, onClose, isCancelAr=false}) => {
  const {state} = useGlobalCtx();

  // console.log(product);
  // const SUB           = ProductSelectors.getSubscription(state, product);
  // const HAS_PAYMENT   = UserSelectors.getProductsPaymentMethod(product, state);
  // const { HAS_PRICE_WARNING, NEW_PRICE } = getSimpPriceWarning(SUB.sku, SUB.expireOn, state.featureFlags);

  // Bill Manager Shenangians
  const BM_TYPE = BillSelector.getBillManagerType(state);
  const QKN_SUB = BillSelector.getQknSubscription(state, state?.country);
  const BUNDLE_HAS_QKN = QKN_SUB?.txnId || false;
  const QKN_SUB_OBJ = BillSelector.getQknSubscriptionObj(QKN_SUB, state?.country);
  const BM_MAX_ENT = QKN_SUB ? BillSelector.getMaxEntitlement(state) : false;
  const BM_DATA = QKN_SUB ? BillSelector.getBmTierData(BM_MAX_ENT) : false;
  // End of Bill Manager Shenangians

  return (
    <>
      <article className={`${S.card} ${S.bundleCard}`}>
        <div className={S.productInfo}>

          <div className={S.leftSide}>
            <div className={S.productHeader}>
              <img alt="square product logo" src={getProductLogo(product, true)} />
              <div className={S.headerText}>
                <ProductName customName={product?.bundleSkuData?.display_name} className={S.acmeName} nameStyle='inline'/>
                {/* <TagLine uriName={'bundle'} className={S.tagLine} /> */}

                <div className={S.subNamesContain}>
                  {product?.subscriptions?.map((sub, i) => {
                    return (
                      <div className={S.subName} key={i}>
                        + <ProductName sub={sub} product={sub.productName} className={S.name} nameStyle='inline'/>
                      </div>
                    );
                  })}
                </div>

                {!isCancelAr &&
                  <SubActionRow product={'bundle'} txnId={product.txnId} onClose={onClose}/>
                }

              </div>
            </div>
          </div>

          <div className={S.rightSide}>
            <Price
              sku={product?.bundleSkuData?.RenewalSKU}
              renewalFrequency={product?.bundleSkuData?.RenewalFrequencyISODuration}
              className={S.priceRow}
              price={product?.bundleSkuData?.Price}
            />

            <Expiry customSub={product?.bundleSub} className={S.productExpiry} />
          </div>
        </div>
      </article>

      {BUNDLE_HAS_QKN && BM_TYPE === 'FREE' &&
        <InfoBm product={'billmanager'} bmType={'PAID'} isCancelAr={isCancelAr} onClose={onClose} />
      }

      {BUNDLE_HAS_QKN && BM_TYPE === 'PAID' &&
        <InfoBm product={'billmanager'} bmType={'PAID'} isCancelAr={isCancelAr} onClose={onClose} />
      }
    </>
  );
};

InfoBundle.displayName = 'InfoBundle';
InfoBundle.propTypes   = {
  product: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  isCancelAr: PropTypes.bool
};

export { InfoBundle };
